import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Id } from 'src/app/models/database/types/id.model';

export class SessionAttributes {

  session: string = null
  datafields: DatafieldsAttributes = []

  constructor(session: string, datafields: DatafieldsAttributes = []) {
    this.session = session
    this.datafields = datafields
  }
}

export class SessionsAttributes extends Array<SessionAttributes> { }

export class DatafieldAttributes {

  type: Id = null
  label: string = null
  value: any = null
  list?: string[]
  minValue?: number = null
  maxValue?: number = null

  constructor(type: Id, label: string, value: any, list?: string[], minValue?: number, maxValue?: number) {
    this.type = type
    this.label = label
    this.value = value
    if (list) {
      this.list = list
    }
    if (minValue && maxValue) {
      this.minValue = minValue
      this.maxValue = maxValue
    }
  }
}

export class DatafieldsAttributes extends Array<DatafieldAttributes> { }

@Injectable({
  providedIn: 'root'
})
export class DatasheetService {

  private datasheetData: SessionsAttributes = []
  datasheetObjectBuilderSubject: Subject<void> = new Subject<void>()
  datasheetObjectBuilder$: Observable<void> = this.datasheetObjectBuilderSubject.pipe(
    filter(() => this.everythingIsValid)
  )
  datafieldValidationSubject: Subject<void> = new Subject<void>()
  everythingIsValid: boolean = true

  constructor() { }

  newDatasheetObject(): void {
    this.datasheetData = []
  }

  get datasheetObject(): SessionsAttributes {
    return this.datasheetData
  }

  addSession(datasheetSession: string): void {
    this.datasheetData.push(new SessionAttributes(datasheetSession))
  }

  buildDatasheetObject(datafieldSession: string, datafieldValue: DatafieldAttributes): void {
    if (this.everythingIsValid) {
      const sessionIndex: number = this.datasheetData.indexOf(this.datasheetData.find(datasheet => datasheet.session === datafieldSession))
      this.datasheetData[sessionIndex].datafields.push(datafieldValue)
      return
    }
  }
}
